export enum ElementTypeEnum {
    Div = 0,
    Span = 1,
    P = 2,
}
